import React from 'react'
import DefaultProgressBar from './DefaultProgressBar'

type Props = {
    current?: number
    negative?: boolean
    max: number
    min?: number
}

const ProgressBarWithValue = ({ current, negative, max, min }: Props) => {
    const val: number = current || 0
    const minValue = min ? Math.abs(min) : max
    if (current && current < 0) {
        negative = true
    }

    return (
        <div className="progressBarWithValueIndicator font-16">
            <div className="progressBarWithValueIndicator__val">
                {Number(val).toFixed(2)}
            </div>

            {negative ? (
                <DefaultProgressBar
                    current={Math.abs(val)}
                    max={minValue}
                    negative={negative}
                />
            ) : (
                <DefaultProgressBar
                    current={Math.abs(val)}
                    max={max}
                    negative={negative}
                />
            )}
        </div>
    )
}

export default ProgressBarWithValue
